const API_BASE_URL = process.env.REACT_APP_API_URL || "https://techstrike-website.onrender.com";

console.log("Using Client API Base URL:", API_BASE_URL);

export default API_BASE_URL;
